import React from "react";
import {RadioGroupKeyValue} from "./radioGroupKeyValue";
import {DateObservable} from "../dateObservable";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import {BooleanObservable} from "../booleanObservable";
import {utcToZonedTime, zonedTimeToUtc} from "date-fns-tz";
import {endOfDay} from "date-fns";

export class DatePickerRadioGroupKeyValue extends RadioGroupKeyValue {
  dateInput: DateObservable;
  enableDatePicker: BooleanObservable;
  minDate: Date;
  timezone: string;

  constructor(
    value: string,
    label: string,
    dateInput: DateObservable,
    minDate: Date,
    timezone: string,
    enableDatePicker?: boolean,
    tooltip?: string,
    isDisabled?: boolean
  ) {
    super(value, label, tooltip, isDisabled);
    this.dateInput = dateInput;
    this.enableDatePicker = new BooleanObservable(enableDatePicker ?? false);
    this.minDate = minDate;
    this.timezone = timezone;
  }

  get hasCustomInput(): boolean {
    return true;
  }

  renderCustomInput(isDisabled: boolean): JSX.Element | null {
    return (
      <DatePicker
        className={classNames("form-control", {
          "is-invalid": !this.dateInput.isValid
        })}
        selected={
          this.enableDatePicker.value
            ? utcToZonedTime(this.dateInput.date ?? new Date(), this.timezone)
            : null
        }
        onChange={(val: Date) => {
          if (val) {
            this.dateInput.setDate(
              zonedTimeToUtc(endOfDay(val), this.timezone)
            );
          } else {
            this.dateInput.setDate(this.minDate);
          }
        }}
        dateFormat={"dd/MM/yyyy"}
        popperPlacement="auto"
        calendarStartDay={1}
        placeholderText={"DD/MM/YYYY"}
        minDate={this.minDate}
        disabled={!this.enableDatePicker.value}
      />
    );
  }

  get enteredValue(): string {
    return this.dateInput.date?.toDateString() ?? "N/A";
  }

  setDate(date: Date | null) {
    this.dateInput.setDate(date);
  }
}
